"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Auftragsart = _interopRequireDefault(require("./Auftragsart"));
var _Auftragsdetails = _interopRequireDefault(require("./Auftragsdetails"));
var _Auftragsposition = _interopRequireDefault(require("./Auftragsposition"));
var _Bearbeiter = _interopRequireDefault(require("./Bearbeiter"));
var _Besteller = _interopRequireDefault(require("./Besteller"));
var _BooleanJN = _interopRequireDefault(require("./BooleanJN"));
var _Order = _interopRequireDefault(require("./Order"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Auftrag model module.
 * @module model/Auftrag
 * @version 1.0.44
 */
var Auftrag = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Auftrag</code>.
   * Detailinformationen zu einem Auftrag
   * @alias module:model/Auftrag
   * @implements module:model/Auftragsposition
   * @param geschaeftsart {module:model/Auftragsart} 
   * @param datum {Date} Datum und Uhrzeit, an dem die Position erstellt wurde (GVARTDAT, DATUM_ZEIT bzw EINDAT) konvertiert
   * @param kennziffer {Number} Kennziffer aus dem Katalog (KENNZ)
   * @param count {Number} Anzahl des Produkts bzw Sortenbetrag (ANZAHL)
   * @param auftragsNummer {Number} Nummer des Auftrags (AUFTRAGNR)
   * @param auftragsStatus {Number} Interner Statuscode (AUFTRAGSTATUS) 1   Order erfasst, Ware noch nicht geliefert (bei Ankäufen) 2   Order bereit zur Abrechnung 3   Order an secore übertragen 4   Abrechnung in secore fehlerhaft 5   Order in secore erfolgreich abgerechnet 6   Storno durchgeführt      9   vorgemerkt zum Storno intern bei der BayernLB 70  TCM-Prüfung läuft 71  gesperrt wg. TCM-Prüfung               
   * @param iban {String} IBAN des Kontos, über das verrechnet wird (IBAN)
   * @param bearbeiter {module:model/Bearbeiter} 
   * @param besteller {module:model/Besteller} 
   * @param order {module:model/Order} 
   * @param auftragsDetails {module:model/Auftragsdetails} 
   */
  function Auftrag(geschaeftsart, datum, kennziffer, count, auftragsNummer, auftragsStatus, iban, bearbeiter, besteller, order, auftragsDetails) {
    _classCallCheck(this, Auftrag);
    _Auftragsposition.default.initialize(this, geschaeftsart, datum, kennziffer, count, auftragsNummer, auftragsStatus, iban);
    Auftrag.initialize(this, geschaeftsart, datum, kennziffer, count, auftragsNummer, auftragsStatus, iban, bearbeiter, besteller, order, auftragsDetails);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Auftrag, null, [{
    key: "initialize",
    value: function initialize(obj, geschaeftsart, datum, kennziffer, count, auftragsNummer, auftragsStatus, iban, bearbeiter, besteller, order, auftragsDetails) {
      obj['geschaeftsart'] = geschaeftsart;
      obj['datum'] = datum;
      obj['kennziffer'] = kennziffer;
      obj['count'] = count;
      obj['auftragsNummer'] = auftragsNummer;
      obj['auftragsStatus'] = auftragsStatus;
      obj['iban'] = iban;
      obj['bearbeiter'] = bearbeiter;
      obj['besteller'] = besteller;
      obj['order'] = order;
      obj['auftragsDetails'] = auftragsDetails;
    }

    /**
     * Constructs a <code>Auftrag</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Auftrag} obj Optional instance to populate.
     * @return {module:model/Auftrag} The populated <code>Auftrag</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Auftrag();
        _Auftragsposition.default.constructFromObject(data, obj);
        if (data.hasOwnProperty('geschaeftsart')) {
          obj['geschaeftsart'] = _Auftragsart.default.constructFromObject(data['geschaeftsart']);
        }
        if (data.hasOwnProperty('datum')) {
          obj['datum'] = _ApiClient.default.convertToType(data['datum'], 'Date');
        }
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'Number');
        }
        if (data.hasOwnProperty('text')) {
          obj['text'] = _ApiClient.default.convertToType(data['text'], 'String');
        }
        if (data.hasOwnProperty('count')) {
          obj['count'] = _ApiClient.default.convertToType(data['count'], 'Number');
        }
        if (data.hasOwnProperty('auftragsNummer')) {
          obj['auftragsNummer'] = _ApiClient.default.convertToType(data['auftragsNummer'], 'Number');
        }
        if (data.hasOwnProperty('auftragsStatus')) {
          obj['auftragsStatus'] = _ApiClient.default.convertToType(data['auftragsStatus'], 'Number');
        }
        if (data.hasOwnProperty('iban')) {
          obj['iban'] = _ApiClient.default.convertToType(data['iban'], 'String');
        }
        if (data.hasOwnProperty('mandatRef')) {
          obj['mandatRef'] = _ApiClient.default.convertToType(data['mandatRef'], 'String');
        }
        if (data.hasOwnProperty('gesamtBetrag')) {
          obj['gesamtBetrag'] = _ApiClient.default.convertToType(data['gesamtBetrag'], 'Number');
        }
        if (data.hasOwnProperty('direktversandKz')) {
          obj['direktversandKz'] = _BooleanJN.default.constructFromObject(data['direktversandKz']);
        }
        if (data.hasOwnProperty('orderId')) {
          obj['orderId'] = _ApiClient.default.convertToType(data['orderId'], 'String');
        }
        if (data.hasOwnProperty('bearbeiter')) {
          obj['bearbeiter'] = _Bearbeiter.default.constructFromObject(data['bearbeiter']);
        }
        if (data.hasOwnProperty('lieferAdresse')) {
          obj['lieferAdresse'] = _ApiClient.default.convertToType(data['lieferAdresse'], 'String');
        }
        if (data.hasOwnProperty('besteller')) {
          obj['besteller'] = _Besteller.default.constructFromObject(data['besteller']);
        }
        if (data.hasOwnProperty('order')) {
          obj['order'] = _Order.default.constructFromObject(data['order']);
        }
        if (data.hasOwnProperty('auftragsDetails')) {
          obj['auftragsDetails'] = _Auftragsdetails.default.constructFromObject(data['auftragsDetails']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Auftrag</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Auftrag</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Auftrag.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['text'] && !(typeof data['text'] === 'string' || data['text'] instanceof String)) {
        throw new Error("Expected the field `text` to be a primitive type in the JSON string but got " + data['text']);
      }
      // ensure the json data is a string
      if (data['iban'] && !(typeof data['iban'] === 'string' || data['iban'] instanceof String)) {
        throw new Error("Expected the field `iban` to be a primitive type in the JSON string but got " + data['iban']);
      }
      // ensure the json data is a string
      if (data['mandatRef'] && !(typeof data['mandatRef'] === 'string' || data['mandatRef'] instanceof String)) {
        throw new Error("Expected the field `mandatRef` to be a primitive type in the JSON string but got " + data['mandatRef']);
      }
      // ensure the json data is a string
      if (data['orderId'] && !(typeof data['orderId'] === 'string' || data['orderId'] instanceof String)) {
        throw new Error("Expected the field `orderId` to be a primitive type in the JSON string but got " + data['orderId']);
      }
      // validate the optional field `bearbeiter`
      if (data['bearbeiter']) {
        // data not null
        _Bearbeiter.default.validateJSON(data['bearbeiter']);
      }
      // ensure the json data is a string
      if (data['lieferAdresse'] && !(typeof data['lieferAdresse'] === 'string' || data['lieferAdresse'] instanceof String)) {
        throw new Error("Expected the field `lieferAdresse` to be a primitive type in the JSON string but got " + data['lieferAdresse']);
      }
      // validate the optional field `besteller`
      if (data['besteller']) {
        // data not null
        _Besteller.default.validateJSON(data['besteller']);
      }
      // validate the optional field `order`
      if (data['order']) {
        // data not null
        _Order.default.validateJSON(data['order']);
      }
      // validate the optional field `auftragsDetails`
      if (data['auftragsDetails']) {
        // data not null
        _Auftragsdetails.default.validateJSON(data['auftragsDetails']);
      }
      return true;
    }
  }]);
}();
Auftrag.RequiredProperties = ["geschaeftsart", "datum", "kennziffer", "count", "auftragsNummer", "auftragsStatus", "iban", "bearbeiter", "besteller", "order", "auftragsDetails"];

/**
 * @member {module:model/Auftragsart} geschaeftsart
 */
Auftrag.prototype['geschaeftsart'] = undefined;

/**
 * Datum und Uhrzeit, an dem die Position erstellt wurde (GVARTDAT, DATUM_ZEIT bzw EINDAT) konvertiert
 * @member {Date} datum
 */
Auftrag.prototype['datum'] = undefined;

/**
 * Kennziffer aus dem Katalog (KENNZ)
 * @member {Number} kennziffer
 */
Auftrag.prototype['kennziffer'] = undefined;

/**
 * Langbezeichung des Produkts (LANGBEZ bzw LANG_BEZ) nur VerseNeo
 * @member {String} text
 */
Auftrag.prototype['text'] = undefined;

/**
 * Anzahl des Produkts bzw Sortenbetrag (ANZAHL)
 * @member {Number} count
 */
Auftrag.prototype['count'] = undefined;

/**
 * Nummer des Auftrags (AUFTRAGNR)
 * @member {Number} auftragsNummer
 */
Auftrag.prototype['auftragsNummer'] = undefined;

/**
 * Interner Statuscode (AUFTRAGSTATUS) 1   Order erfasst, Ware noch nicht geliefert (bei Ankäufen) 2   Order bereit zur Abrechnung 3   Order an secore übertragen 4   Abrechnung in secore fehlerhaft 5   Order in secore erfolgreich abgerechnet 6   Storno durchgeführt      9   vorgemerkt zum Storno intern bei der BayernLB 70  TCM-Prüfung läuft 71  gesperrt wg. TCM-Prüfung               
 * @member {Number} auftragsStatus
 */
Auftrag.prototype['auftragsStatus'] = undefined;

/**
 * IBAN des Kontos, über das verrechnet wird (IBAN)
 * @member {String} iban
 */
Auftrag.prototype['iban'] = undefined;

/**
 * Mandatsreferenz (MANDAT_REF)
 * @member {String} mandatRef
 */
Auftrag.prototype['mandatRef'] = undefined;

/**
 * Gesamtbetrag in Euro (GESAMT_BETR) nur VerseNeo
 * @member {Number} gesamtBetrag
 */
Auftrag.prototype['gesamtBetrag'] = undefined;

/**
 * @member {module:model/BooleanJN} direktversandKz
 */
Auftrag.prototype['direktversandKz'] = undefined;

/**
 * ID der Order, wird für reprint benötigt aber erst vom Frontend eingetragen, wenn eine Reprint ausgelöst wurde
 * @member {String} orderId
 */
Auftrag.prototype['orderId'] = undefined;

/**
 * @member {module:model/Bearbeiter} bearbeiter
 */
Auftrag.prototype['bearbeiter'] = undefined;

/**
 * Adresse, an die die Ware geliefert wurde, wenn vorhanden
 * @member {String} lieferAdresse
 */
Auftrag.prototype['lieferAdresse'] = undefined;

/**
 * @member {module:model/Besteller} besteller
 */
Auftrag.prototype['besteller'] = undefined;

/**
 * @member {module:model/Order} order
 */
Auftrag.prototype['order'] = undefined;

/**
 * @member {module:model/Auftragsdetails} auftragsDetails
 */
Auftrag.prototype['auftragsDetails'] = undefined;

// Implement Auftragsposition interface:
/**
 * @member {module:model/Auftragsart} geschaeftsart
 */
_Auftragsposition.default.prototype['geschaeftsart'] = undefined;
/**
 * Datum und Uhrzeit, an dem die Position erstellt wurde (GVARTDAT, DATUM_ZEIT bzw EINDAT) konvertiert
 * @member {Date} datum
 */
_Auftragsposition.default.prototype['datum'] = undefined;
/**
 * Kennziffer aus dem Katalog (KENNZ)
 * @member {Number} kennziffer
 */
_Auftragsposition.default.prototype['kennziffer'] = undefined;
/**
 * Langbezeichung des Produkts (LANGBEZ bzw LANG_BEZ) nur VerseNeo
 * @member {String} text
 */
_Auftragsposition.default.prototype['text'] = undefined;
/**
 * Anzahl des Produkts bzw Sortenbetrag (ANZAHL)
 * @member {Number} count
 */
_Auftragsposition.default.prototype['count'] = undefined;
/**
 * Nummer des Auftrags (AUFTRAGNR)
 * @member {Number} auftragsNummer
 */
_Auftragsposition.default.prototype['auftragsNummer'] = undefined;
/**
 * Interner Statuscode (AUFTRAGSTATUS) 1   Order erfasst, Ware noch nicht geliefert (bei Ankäufen) 2   Order bereit zur Abrechnung 3   Order an secore übertragen 4   Abrechnung in secore fehlerhaft 5   Order in secore erfolgreich abgerechnet 6   Storno durchgeführt      9   vorgemerkt zum Storno intern bei der BayernLB 70  TCM-Prüfung läuft 71  gesperrt wg. TCM-Prüfung               
 * @member {Number} auftragsStatus
 */
_Auftragsposition.default.prototype['auftragsStatus'] = undefined;
/**
 * IBAN des Kontos, über das verrechnet wird (IBAN)
 * @member {String} iban
 */
_Auftragsposition.default.prototype['iban'] = undefined;
/**
 * Mandatsreferenz (MANDAT_REF)
 * @member {String} mandatRef
 */
_Auftragsposition.default.prototype['mandatRef'] = undefined;
/**
 * Gesamtbetrag in Euro (GESAMT_BETR) nur VerseNeo
 * @member {Number} gesamtBetrag
 */
_Auftragsposition.default.prototype['gesamtBetrag'] = undefined;
/**
 * @member {module:model/BooleanJN} direktversandKz
 */
_Auftragsposition.default.prototype['direktversandKz'] = undefined;
/**
 * ID der Order, wird für reprint benötigt aber erst vom Frontend eingetragen, wenn eine Reprint ausgelöst wurde
 * @member {String} orderId
 */
_Auftragsposition.default.prototype['orderId'] = undefined;
/**
 * @member {module:model/Bearbeiter} bearbeiter
 */
_Auftragsposition.default.prototype['bearbeiter'] = undefined;
/**
 * Adresse, an die die Ware geliefert wurde, wenn vorhanden
 * @member {String} lieferAdresse
 */
_Auftragsposition.default.prototype['lieferAdresse'] = undefined;
var _default = exports.default = Auftrag;